import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, CardHeader, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData  } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft, Droplet, Settings } from "react-feather";


function AddEdit_CityMaster() {
  const API_URL_SAVE = "CityMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/CityMaster/Id";

  const [state, setState] = useState({ 
    id: 0, 
    StateMaster: [],
    formData: { 
      Name: "" ,
      F_StateMaster:""
    } 
  });
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/StateMaster`;

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    Fn_FillListData(dispatch, setState, "StateMaster", API_URL + "/Id/0");

    if (Id > 0) {
      setState((prevState) => ({ ...prevState, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  // Auto-focus on Name field when component mounts
  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  // Validation Schema
  const validationSchema = Yup.object({
    Name: Yup.string().required("City name is required"),
    F_StateMaster: Yup.string().required("State is required"),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("Name", values.Name || "");
    formData.append("F_StateMaster", values.F_StateMaster || 0);
    formData.append("UserId", obj===null || obj===undefined ? 0 : obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/CityMaster"
    );
  };

  return (
    <div className="master-form-container" style={{padding: '10px 0'}}>
      <div className="container-fluid px-2">
        
        {/* Form Card */}
        <Row className="justify-content-center">
          <Col lg={10} md={12} sm={12}>
            <Card className="master-form-card master-form-slide-in">
              <CardHeader className="master-form-card-header" style={{padding: '12px 20px'}}>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="form-icon-wrapper me-2">
                      <Settings size={18} color="#6D68CB" />
                    </div>
                    <div>
                      <h5 className="mb-0 fw-bold">City Master</h5>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="master-form-card-body">
                <Formik
                  initialValues={{ Name: state.formData.Name || "" ,
                  F_StateMaster: state.formData.F_StateMaster || "" }} 
                  enableReinitialize={true}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <Row className="master-form-row">
                        <Col lg={12}>
                          <div className="form-group mb-4">
                            <label htmlFor="Name" className="master-form-label">
                              <Settings size={16} className="me-2" />
                              City Name <span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              <Field
                                innerRef={nameRef}
                                className={`master-form-input ${errors.Name && touched.Name ? 'is-invalid' : ''}`}
                                type="text"
                                name="Name"
                                placeholder="Enter city name"
                              />
                              <div className="input-icon">
                                <Settings size={16} color="#6c757d" />
                              </div>
                            </div>
                            <ErrorMessage name="Name" component="div" className="master-form-error" />
                            <div className="form-help-text">
                              <i className="fas fa-lightbulb me-1"></i>
                              Choose a descriptive name for the city
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="master-form-row">
                      <Col lg={12}>
                      <div className="form-group mb-4">
                          <label htmlFor="F_StateMaster" className="master-form-label">
                           
                            State <span className="required">*</span>
                          </label>
                          <div className="input-wrapper">
                            <Field
                              as="select"
                              className={`master-form-input ${errors.F_StateMaster && touched.F_StateMaster ? 'is-invalid' : ''}`}
                              name="F_StateMaster"
                            >
                              <option value="">Select State</option>
                              {state.StateMaster.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </Field>
                            <div className="input-icon">
                             
                            </div>
                          </div>
                          <ErrorMessage name="F_StateMaster" component="div" className="master-form-error" />
                          <div className="form-help-text">
                            <i className="fas fa-lightbulb me-1"></i>
                            Select the State
                          </div>
                        </div>
                        </Col>
                        </Row>

                      <div className="master-form-actions">
                        <div className="d-flex gap-3 justify-content-center">
                          <Button
                            type="button"
                            className="master-form-cancel-btn"
                            onClick={() => navigate("/CityMaster")}
                            variant="outline-secondary"
                            size="lg"
                          >
                            <ArrowLeft size={18} className="me-2" />
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            className="master-form-submit-btn"
                            disabled={isSubmitting}
                            size="lg"
                          >
                            {isSubmitting ? (
                              <div className="master-form-loading me-2" />
                            ) : (
                              <Save size={18} className="me-2" />
                            )}
                            {state.id > 0 ? "Update" : "Save"} City
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AddEdit_CityMaster;